import { render, staticRenderFns } from "./ManifestKlaimCCPd.vue?vue&type=template&id=e13b77e4&scoped=true&"
import script from "./ManifestKlaimCCPd.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimCCPd.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimCCPd.vue?vue&type=style&index=0&id=e13b77e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13b77e4",
  null
  
)

export default component.exports